import Api from "./api/index.js";
import App from "./app.js";
import i18n from "./i18n.js";
import { getItem } from "./storage.js";
import { SafeArea } from "@capacitor-community/safe-area";

const { ENV, redom } = window;
const { DARK_MODE } = ENV;
const { mount } = redom;

const api = new Api({ i18n });

if (DARK_MODE) {
  const darkMode = window.matchMedia("(prefers-color-scheme: dark)");

  let prevDarkMode;

  function updateDarkMode() {
    if (darkMode.matches) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
    if (darkMode.matches !== prevDarkMode) {
      prevDarkMode = darkMode.matches;
      api.darkMode = darkMode.matches;
      api.update();
    }
  }
  darkMode.addEventListener("change", updateDarkMode);

  updateDarkMode();
}

const app = new App({ api, i18n });

i18n.load().then(async () => {
  api.update();

  const termsRead = await getItem("termsRead");
  api.termsRead =
    !i18n("TERMS") ||
    i18n("TERMS") === "TERMS" ||
    termsRead === i18n("__checksums.TERMS");

  const bannerAcknowledged = await getItem("bannerAcknowledged");
  api.bannerAcknowledged =
    !i18n("BANNER") ||
    i18n("BANNER") === "BANNER" ||
    bannerAcknowledged === i18n("__checksums.BANNER");

  api.update();
});

api.app = app;

window.api = api;

api.update();

mount(document.body, app);

if (ENV.THEME === "austrocontrol" || (!ENV.THEME && api.query.austrocontrol)) {
  document.body.classList.add("austrocontrol");
} else if (ENV.THEME === "eans" || (!ENV.THEME && api.query.eans)) {
  document.body.classList.add("eans");
} else if (ENV.THEME === "on" || (!ENV.THEME && api.query.on)) {
  document.body.classList.add("on");
} else if (ENV.THEME === "bulatsa" || (!ENV.THEME && api.query.bulatsa)) {
  document.body.classList.add("bulatsa");
} else if (ENV.THEME === "wtd61" || (!ENV.THEME && api.query.wtd61)) {
  document.body.classList.add("wtd61");
} else if (ENV.THEME === "lfv" || (!ENV.THEME && api.query.lfv)) {
  document.body.classList.add("lfv");
} else if (ENV.THEME === "navcanada" || (!ENV.THEME && api.query.navcanada)) {
  document.body.classList.add("navcanada");
}

if (ENV.LEGACY_UI || api.query.legacyui) {
  document.body.classList.add("legacy-ui");
}

SafeArea.enable({
  config: {
    customColorsForSystemBars: true,
    statusBarColor: "#00000000", // transparent
    statusBarContent: "light",
    navigationBarColor: "#00000000", // transparent
    navigationBarContent: "light",
  },
});
